<!-- new ui in horizontal list -->
<div class="email-activity-actions d-flex flex-wrap gap-x-1">
    <button mat-stroked-button matTooltip="Read" (click)="activityConfirmation('read')"
        *ngIf="show_read && page_type !== 'read'" [disabled]="selected_mails?.length === 0">
        <i class="ri-mail-check-line"></i>
        <!-- <span>Read</span> -->
    </button>

    <button mat-stroked-button matTooltip="Unread" (click)="activityConfirmation('unread')" *ngIf="show_unread"
        [ngClass]="{ 'ms-10': page_type === 'read' }" [disabled]="selected_mails?.length === 0">
        <i class="ri-mail-unread-line"></i>
        <!-- <span>Unread</span> -->
    </button>
    <button mat-stroked-button matTooltip="Done"
        (click)="activityConfirmation( isMMRTeam ? mail_type_ids.MMRarchived : mail_type_ids.archived)"
        *ngIf="show_archive && showDoneButton">
        <i class="ri-archive-line"></i>
        <!-- <span>Archive</span> -->
    </button>
    <button mat-stroked-button matTooltip="Junk" (click)="activityConfirmation(mail_type_ids.junk)" *ngIf="show_junk"
        [disabled]="selected_mails?.length === 0">
        <i class="ri-mail-forbid-line"></i>
        <!-- <span>Junk</span> -->
    </button>

    <button mat-stroked-button matTooltip="Important" (click)="activityConfirmation(mail_type_ids.important)"
        *ngIf="show_important" [disabled]="selected_mails?.length === 0">
        <i class="ri-mail-star-line"></i>
    </button>

    <button mat-stroked-button matTooltip="Back To Inbox" (click)="activityConfirmation(mail_type_ids.inbox)"
        *ngIf="show_inbox" [disabled]="selected_mails?.length === 0">
        <i class="ri-mail-download-line"></i>
        <!-- <span>Important</span> -->
    </button>

    <button mat-stroked-button matTooltip="Delete Permanently" (click)="activityConfirmation(mail_type_ids.remove)"
        *ngIf="show_delete" [disabled]="selected_mails?.length === 0">
        <i class="ri-delete-bin-2-line"></i>
        <!-- <span>Important</span> -->
    </button>
    <!-- <button
        mat-stroked-button
        matTooltip="Assign"
        (click)="openAssignPopup()"
        *ngIf="showAssignButton"
        [disabled]="selected_mails?.length === 0"
        class="assign-btn"
    >
        <i class="ri-mail-send-line"></i>
        <span>Assign</span>
    </button> -->
    <button mat-stroked-button matTooltip="Assign" (click)="openAssignPopup()"
        *ngIf="showAssignButton && menu_type.id != mail_type_ids.draft" [disabled]="selected_mails?.length === 0"
        class="assign-btn">
        <i class="ri-mail-send-line"></i>
        <span>Assign</span>
    </button>
    <!-- move to hide -->
    <!-- <button mat-stroked-button [matMenuTriggerFor]="menu" (menuOpened)="getFolders()" *ngIf="show_move_to">
        <i class="ri-more-2-fill"></i>
    </button> -->
    <mat-menu #menu="matMenu" class="dotMenu monthMenu" xPosition="before">
        <button mat-menu-item type="button" [matMenuTriggerFor]="move_to"
            class="bg-transparent border-none position-relative pe-30">
            <!-- <i class="ri-file-transfer-line"></i>  -->
            Move to
        </button>
        <mat-menu #move_to="matMenu" class="dotMenu monthMenu" xPosition="before">
            <ng-container *ngIf="user_details && mailAllotmentFolders?.length">
                <ng-container *ngFor="let folders of mailAllotmentFolders">
                    <button mat-menu-item type="button" class="bg-transparent border-none position-relative"
                        (click)="moveToFolders('folder', folders.id)">
                        <i class="ri-archive-line"></i> {{ folders?.name }}
                    </button>
                </ng-container>
            </ng-container>
        </mat-menu>
    </mat-menu>

    <!-- <button
        mat-icon-button
        matTooltip="Read"
        (click)="activityConfirmation('read')"
        *ngIf="show_read && page_type !== 'read'"
        [disabled]="selected_mails?.length === 0"
    >
        <i class="ri-mail-check-line"></i>
    </button>
    <button
        mat-icon-button
        matTooltip="Unread"
        (click)="activityConfirmation('unread')"
        *ngIf="show_unread"
        [ngClass]="{ 'ms-10': page_type === 'read' }"
        [disabled]="selected_mails?.length === 0"
    >
        <i class="ri-mail-unread-line"></i>
    </button>
    <button
        mat-icon-button
        matTooltip="Archive"
        (click)="activityConfirmation(mail_type_ids.archived)"
        *ngIf="show_archive"
        [disabled]="selected_mails?.length === 0"
    >
        <i class="ri-archive-line"></i>
    </button>
    <button
        mat-icon-button
        matTooltip="Junk"
        (click)="activityConfirmation(mail_type_ids.junk)"
        *ngIf="show_junk"
        [disabled]="selected_mails?.length === 0"
    >
        <i class="ri-mail-forbid-line"></i>
    </button>
    <button
        mat-icon-button
        matTooltip="Important"
        (click)="activityConfirmation(mail_type_ids.important)"
        *ngIf="show_important"
        [disabled]="selected_mails?.length === 0"
    >
        <i class="ri-information-line"></i>
    </button> -->
</div>
<!-- <button mat-icon-button matTooltip="Share" (click)="share()" *ngIf="show_shared">
    <i class="ri-share-line"></i>
</button> -->